import { useEffect, useState } from "react";
import api from "./api";

// useSWR — stale-while-revalidate for any GET endpoint.
//
// Returns `{ data, loaded, setData, refresh }`.
//   - `data` starts as the cached value (or fallback) for instant first paint.
//   - `loaded` is false until the FIRST live network response lands; flip to
//     true on success so callers can gate sensitive UI (e.g. CMS labels)
//     until they know they're showing the truth and not a stale snapshot.
//   - `setData` is exposed for optimistic updates.
//   - `refresh` re-runs the GET; useful after mutations.
export function useSWR(path, fallback) {
  const [data, setData] = useState(() => {
    const cached = api.getCached(path);
    return cached !== null && cached !== undefined ? cached : fallback;
  });
  const [loaded, setLoaded] = useState(false);
  const refresh = () => api.get(path).then((r) => {
    setData(r.data);
    setLoaded(true);
    return r.data;
  }).catch(() => { setLoaded(true); });
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [path]);
  return { data, loaded, setData, refresh };
}

export function clearSWRCache() { /* deprecated; api.clearApiCache() does the work */ }
